import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BreadcrumbNav from '@/components/feature/BreadcrumbNav';
import SchemaOrg from '@/components/feature/SchemaOrg';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

const articleImages: Record<string, string> = {
  'article-beginner-01': 'https://readdy.ai/api/search-image?query=First%20person%20view%20entering%20a%20dark%20fantasy%20dungeon%20entrance%2C%20torch%20in%20hand%20illuminating%20rough%20stone%20walls%20covered%20in%20moss%2C%20ancient%20wooden%20door%20slightly%20ajar%20with%20warm%20light%20spilling%20through%2C%20cinematic%20game%20environment%20concept%20art%2C%20rich%20atmospheric%20lighting%20with%20amber%20and%20dark%20brown%20tones&width=1200&height=630&seq=article-beginner-01&orientation=landscape',
  'article-beginner-02': 'https://readdy.ai/api/search-image?query=Adventurer%20camping%20by%20a%20small%20campfire%20inside%20a%20dark%20cave%2C%20cooking%20pot%20hanging%20over%20flames%2C%20survival%20gear%20spread%20on%20stone%20floor%2C%20warm%20firelight%20dancing%20on%20rough%20cave%20walls%2C%20dark%20fantasy%20survival%20scene%20with%20cozy%20yet%20tense%20atmosphere&width=1200&height=630&seq=article-beginner-02&orientation=landscape',
  'article-beginner-03': 'https://readdy.ai/api/search-image?query=Heavily%20armored%20warrior%20standing%20guard%20in%20dark%20dungeon%20corridor%2C%20massive%20shield%20reflecting%20torchlight%2C%20ornate%20plate%20armor%20with%20battle%20scars%2C%20defensive%20stance%20ready%20for%20combat%2C%20dark%20fantasy%20character%20portrait%2C%20dramatic%20chiaroscuro%20lighting%20with%20warm%20amber%20highlights&width=1200&height=630&seq=article-beginner-03&orientation=landscape',
  'article-char-01': 'https://readdy.ai/api/search-image?query=Elegant%20moon%20elf%20female%20character%20with%20silver%20hair%20and%20pale%20skin%20in%20dark%20cave%20setting%2C%20ethereal%20blue%20white%20glow%20emanating%20from%20her%20hands%2C%20wearing%20flowing%20elven%20robes%20with%20lunar%20motifs%2C%20melancholic%20expression%2C%20dark%20fantasy%20character%20art%2C%20soft%20moonlight%20contrasting%20with%20cave%20darkness&width=1200&height=630&seq=article-char-01&orientation=landscape',
  'article-char-02': 'https://readdy.ai/api/search-image?query=Massive%20orc%20warrior%20character%20with%20green%20gray%20skin%20and%20tribal%20tattoos%2C%20holding%20a%20giant%20battle%20axe%2C%20standing%20in%20dark%20cave%20with%20defiant%20expression%2C%20battle%20worn%20leather%20armor%20with%20bone%20ornaments%2C%20dark%20fantasy%20character%20concept%20art%2C%20dramatic%20side%20lighting&width=1200&height=630&seq=article-char-02&orientation=landscape',
  'article-char-03': 'https://readdy.ai/api/search-image?query=Collection%20of%20fantasy%20NPC%20characters%20in%20a%20dark%20underground%20tavern%20setting%2C%20dwarf%20blacksmith%20at%20forge%2C%20mysterious%20hooded%20merchant%20at%20counter%2C%20old%20wizard%20reading%20scrolls%2C%20warm%20firelight%20illuminating%20rough%20stone%20interior%2C%20dark%20fantasy%20gathering%20scene&width=1200&height=630&seq=article-char-03&orientation=landscape',
  'article-story-01': 'https://readdy.ai/api/search-image?query=Ancient%20stone%20mural%20carved%20into%20cave%20wall%20depicting%20epic%20battle%20scene%20between%20elves%20and%20goblin%20armies%20under%20a%20dark%20moon%2C%20mysterious%20runes%20and%20glowing%20crystals%20embedded%20in%20the%20carving%2C%20torchlight%20revealing%20hidden%20details%2C%20dark%20fantasy%20archaeological%20discovery%20scene&width=1200&height=630&seq=article-story-01&orientation=landscape',
  'article-story-02': 'https://readdy.ai/api/search-image?query=Mysterious%20glowing%20portal%20opening%20in%20dark%20cave%20chamber%2C%20three%20branching%20paths%20illuminated%20by%20different%20colored%20magical%20lights%2C%20golden%20warm%20light%20on%20one%20path%2C%20emerald%20green%20on%20another%2C%20deep%20crimson%20on%20the%20third%2C%20symbolic%20crossroads%20scene&width=1200&height=630&seq=article-story-02&orientation=landscape',
  'article-map-01': 'https://readdy.ai/api/search-image?query=Weathered%20parchment%20style%20fantasy%20dungeon%20map%20with%20detailed%20room%20layouts%20and%20mysterious%20markings%2C%20compass%20rose%20in%20corner%2C%20candle%20wax%20drips%20on%20edges%2C%20torchlight%20reflecting%20off%20the%20aged%20paper%20surface%2C%20cartography%20aesthetic%20with%20sepia%20and%20warm%20brown%20tones&width=1200&height=630&seq=article-map-01&orientation=landscape',
  'article-map-02': 'https://readdy.ai/api/search-image?query=Adventurer%20discovering%20a%20hidden%20passage%20behind%20crumbling%20stone%20wall%20in%20dark%20cave%2C%20glowing%20runes%20on%20the%20floor%20revealing%20secret%20door%20mechanism%2C%20treasure%20chest%20visible%20through%20the%20gap%2C%20sense%20of%20discovery%20and%20mystery&width=1200&height=630&seq=article-map-02&orientation=landscape',
  'article-equip-01': 'https://readdy.ai/api/search-image?query=Collection%20of%20fantasy%20weapons%20and%20armor%20displayed%20on%20tiered%20pedestals%20in%20dark%20underground%20vault%2C%20legendary%20sword%20glowing%20with%20golden%20light%20at%20the%20top%2C%20various%20shields%20axes%20and%20staves%20on%20lower%20tiers%2C%20treasure%20vault%20atmosphere&width=1200&height=630&seq=article-equip-01&orientation=landscape',
  'article-equip-02': 'https://readdy.ai/api/search-image?query=Dwarf%20blacksmith%20working%20at%20fiery%20forge%20in%20underground%20cave%20workshop%2C%20hammer%20striking%20glowing%20metal%20on%20anvil%2C%20various%20crafted%20weapons%20hanging%20on%20stone%20walls%2C%20alchemy%20table%20with%20bubbling%20potions%20nearby%2C%20dark%20fantasy%20crafting%20scene&width=1200&height=630&seq=article-equip-02&orientation=landscape',
  'article-boss-01': 'https://readdy.ai/api/search-image?query=Giant%20spider%20queen%20boss%20in%20dark%20underground%20cavern%2C%20massive%20web%20spanning%20across%20the%20chamber%2C%20glowing%20red%20eyes%20and%20crystalline%20carapace%20reflecting%20torchlight%2C%20adventurers%20in%20defensive%20formation%20below%2C%20epic%20dark%20fantasy%20boss%20battle%20scene&width=1200&height=630&seq=article-boss-01&orientation=landscape',
  'article-boss-02': 'https://readdy.ai/api/search-image?query=Epic%20final%20boss%20confrontation%20with%20massive%20goblin%20king%20on%20dark%20throne%20surrounded%20by%20treasure%20and%20glowing%20crystals%2C%20hero%20standing%20defiantly%20with%20sword%20raised%2C%20dramatic%20lighting%20with%20intense%20golden%20and%20emerald%20energy%20swirling%2C%20cinematic%20dark%20fantasy%20battle&width=1200&height=630&seq=article-boss-02&orientation=landscape',
};

const relatedImages: Record<string, string> = {
  'article-beginner-01': 'https://readdy.ai/api/search-image?query=First%20person%20view%20entering%20a%20dark%20fantasy%20dungeon%20entrance%2C%20torch%20in%20hand%20illuminating%20rough%20stone%20walls%2C%20ancient%20wooden%20door%20ajar%2C%20cinematic%20game%20concept%20art&width=600&height=400&seq=article-beginner-01&orientation=landscape',
  'article-beginner-03': 'https://readdy.ai/api/search-image?query=Heavily%20armored%20warrior%20in%20dark%20dungeon%20corridor%2C%20massive%20shield%20reflecting%20torchlight%2C%20ornate%20plate%20armor%2C%20dark%20fantasy%20character%20portrait&width=600&height=400&seq=article-beginner-03&orientation=landscape',
  'article-char-01': 'https://readdy.ai/api/search-image?query=Elegant%20moon%20elf%20female%20with%20silver%20hair%20in%20dark%20cave%2C%20ethereal%20glow%2C%20flowing%20elven%20robes%2C%20dark%20fantasy%20character%20art&width=600&height=400&seq=article-char-01&orientation=landscape',
  'article-story-01': 'https://readdy.ai/api/search-image?query=Ancient%20stone%20mural%20carved%20into%20cave%20wall%2C%20epic%20battle%20scene%2C%20mysterious%20runes%2C%20torchlight%2C%20dark%20fantasy%20archaeological%20scene&width=600&height=400&seq=article-story-01&orientation=landscape',
  'article-map-01': 'https://readdy.ai/api/search-image?query=Weathered%20parchment%20fantasy%20dungeon%20map%20with%20detailed%20layouts%2C%20compass%20rose%2C%20candlelight%2C%20cartography%20aesthetic&width=600&height=400&seq=article-map-01&orientation=landscape',
  'article-equip-01': 'https://readdy.ai/api/search-image?query=Fantasy%20weapons%20and%20armor%20displayed%20on%20pedestals%20in%20underground%20vault%2C%20legendary%20sword%20glowing%2C%20treasure%20vault%20atmosphere&width=600&height=400&seq=article-equip-01&orientation=landscape',
  'article-boss-01': 'https://readdy.ai/api/search-image?query=Giant%20spider%20queen%20in%20dark%20cavern%2C%20massive%20web%2C%20glowing%20red%20eyes%2C%20adventurers%20in%20defensive%20formation%2C%20epic%20boss%20battle&width=600&height=400&seq=article-boss-01&orientation=landscape',
  'article-boss-02': 'https://readdy.ai/api/search-image?query=Massive%20goblin%20king%20on%20dark%20throne%2C%20hero%20with%20sword%20raised%2C%20golden%20and%20emerald%20energy%2C%20epic%20final%20boss%20confrontation&width=600&height=400&seq=article-boss-02&orientation=landscape',
};

function getCategoryName(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat?.name || slug;
}

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center">
          <i className="ri-error-warning-line text-5xl text-foreground-300 mb-4 block"></i>
          <h1 className="text-2xl font-heading font-bold text-foreground-950 mb-2">文章未找到</h1>
          <p className="text-foreground-500 mb-4">你访问的文章不存在或已被移除</p>
          <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium text-sm whitespace-nowrap cursor-pointer">
            <i className="ri-arrow-left-line mr-1"></i>返回首页
          </Link>
        </div>
      </div>
    );
  }

  const relatedArticles = articles
    .filter((a) => a.slug !== article.slug && a.category === article.category)
    .slice(0, 3);

  const articleImage = articleImages[article.imageSeq];
  const catName = getCategoryName(article.category);

  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="Article"
        articleData={{
          headline: article.title,
          description: article.excerpt,
          datePublished: article.date,
          dateModified: article.date,
          author: article.author,
          image: articleImage || '',
          url: `https://goblin-cave-guide.readdy.site/article/${article.slug}`,
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${article.title} - 哥布林的洞窟`,
          description: article.excerpt,
        }}
      />

      <Navbar />

      <main className="pt-16">
        <article>
          <header className="relative w-full h-[280px] md:h-[400px] flex items-end overflow-hidden">
            <div className="absolute inset-0">
              {articleImage && (
                <img
                  src={articleImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top"
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/30"></div>
            </div>
            <div className="relative z-10 w-full px-4 md:px-6 pb-8 md:pb-12">
              <div className="max-w-4xl mx-auto">
                <div className="flex flex-wrap items-center gap-2 mb-3">
                  <Link
                    to={`/category/${article.category}`}
                    className="px-3 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap cursor-pointer"
                  >
                    {catName}
                  </Link>
                  {article.tags.map((tag) => (
                    <span key={tag} className="px-3 py-1 bg-background-50/20 text-background-50 text-xs rounded-full whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
                <h1 className="text-xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 mb-3 leading-tight">
                  {article.title}
                </h1>
                <div className="flex items-center gap-4 text-sm text-background-50/70">
                  <span><i className="ri-user-line mr-1"></i>{article.author}</span>
                  <span><i className="ri-calendar-line mr-1"></i>{article.date}</span>
                  <span><i className="ri-time-line mr-1"></i>{article.readTime}</span>
                </div>
              </div>
            </div>
          </header>

          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <BreadcrumbNav
              items={[
                { label: '首页', href: '/' },
                { label: catName, href: `/category/${article.category}` },
                { label: article.title },
              ]}
            />
          </div>

          <div className="max-w-4xl mx-auto px-4 md:px-6 py-8 md:py-12">
            <div
              className="prose prose-lg max-w-none
                prose-headings:font-heading prose-headings:text-foreground-950
                prose-h2:text-xl md:prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-4
                prose-h3:text-lg md:prose-h3:text-xl prose-h3:mt-8 prose-h3:mb-3
                prose-h4:text-base md:prose-h4:text-lg prose-h4:mt-6 prose-h4:mb-2
                prose-p:text-foreground-700 prose-p:leading-relaxed prose-p:mb-4
                prose-strong:text-foreground-900 prose-strong:font-semibold
                prose-li:text-foreground-700 prose-li:leading-relaxed
                prose-ul:my-4 prose-ol:my-4
                [&_ul>li]:mb-1.5 [&_ol>li]:mb-1.5"
              dangerouslySetInnerHTML={{ __html: article.contentHtml }}
            />
          </div>
        </article>

        {relatedArticles.length > 0 && (
          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
                相关攻略
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {relatedArticles.map((ra) => (
                  <Link
                    key={ra.slug}
                    to={`/article/${ra.slug}`}
                    className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
                  >
                    <div className="h-36 overflow-hidden">
                      <img
                        src={relatedImages[ra.imageSeq] || articleImage}
                        alt={ra.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="font-heading font-bold text-foreground-950 text-sm leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {ra.title}
                      </h3>
                      <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
                        <span>{ra.readTime}</span>
                        <span>{ra.date}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>

      <Footer />
    </>
  );
}